/*
 * Copyright © 2025. Legalbird eine Marke der Legalbird GmbH
 */

import { AbstractCase } from "../../../types/Entities/AbstractCase";
import { STATUS_ADMINISTRATIVE_PROCEEDINGS } from "../leadStatus";
import { Stack, Typography } from "@mui/material";
import Button from "@mui/material/Button";
import { getCaseLink } from "../../productService";
import React from "react";
import { Link } from "react-router";

export const ExtraContent = ({ litigationCase }: { litigationCase: AbstractCase }) => {
  if (litigationCase.leadStatus === STATUS_ADMINISTRATIVE_PROCEEDINGS) {
    return (
      <Stack spacing={3} sx={{ marginTop: 2 }}>
        <Typography>
          Es kam inzwischen zu einer Einigung mit der Gegenseite und der Fall kann abgeschlossen werden? Dann teilen Sie uns dies bitte hier kurz mit:
        </Typography>
        <Button component={Link} to={getCaseLink(litigationCase) + "/abschliessen"} variant="contained" color="primary" fullWidth>
          Fall abschließen
        </Button>
        <Typography>Sie haben eine nicht zufriedenstellende Reaktion der Gegenseite erhalten? Dann laden Sie uns diese bitte hoch:</Typography>
        <Button component={Link} to={getCaseLink(litigationCase) + "#upload"} variant="contained" color="primary" fullWidth>
          Dokument hochladen
        </Button>
      </Stack>
    );
  }

  return null;
};
